import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./SubModuleSetup.css";
import SearchView from "../../widgets/SearchView";
import SubModuleSetupSearchForm from './SubModuleSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import { ViewContainer } from "./../../View.jsx";
import CardLayout from '../../widgets/Card';
import withMenuPermission from "../../widgets/withMenuPermission";

const headCells = [
    { id: 'SubModuleCode', numeric: false, disablePadding: true, label: 'QCTO Sub Module ID' },
    { id: 'SubModuleTitle', numeric: false, disablePadding: true, label: 'QCTO Sub Module Title' }
];

const modelTemplate = [
    { Name: "SubModuleCode", Value: "" },
    { Name: "SubModuleTitle", Value: "" }
];



const utils = new ViewUtils();

class SubModuleSetupSearch extends Component {
    constructor(props) {
        super(props);

        this.searchParameters = !utils.isNull(this.props.programmeId) ? [
            { Name: "SubModuleCode", Value: "" },
            { Name: "SubModuleTitle", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "ProgrammeType", Value: this.props.programmeType }
        ]
            :
            [
                { Name: "SubModuleCode", Value: "" },
                { Name: "SubModuleTitle", Value: "" }
            ];

        let model = !utils.isNull(this.props.programmeId) ?
            {
                SubModuleCode: "",
                SubModuleTitle: "",
                ProgrammeID: this.props.programmeId,
                ProgrammeType: this.props.programmeType
            }
            :
            {
                SubModuleCode: "",
                SubModuleTitle: ""
            }

        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }

        if (!utils.isNull(props.personId)) {
            model.PersonID = props.personId;
            this.searchParameters.push({ Name: "PersonID", Value: props.personId })
        }

        this.state = !utils.isNull(this.props.programmeId) ?
            {
                model: model,
                keyUpSwitch: false
            }
            :
            {
                model: model,
                keyUpSwitch: false
            };  

        //TODO: Add url for sub module removal
        this.deleteUrl = ""

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove Sub Module', icon: "DeleteIcon", disabled: true, visible: this.props.menuPermissionItem.Delete}
                    ]
                }
            ]
        };
    }

    clearSearch(e) {
        this.setState({
            model: {
                SubModuleCode: "",
                SubModuleTitle: "",
                ProgrammeID: this.props.programmeId,
                ProgrammeType: this.props.programmeType
            }
        });
    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

  

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/subModuleSetup/getsearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/subModuleSetup/RemoveSubModule"} useDeletePost={true}
                    entityViewPath='/subModuleSetup' customMessage={this.props.customMessage} clearPress={(e) => { this.clearSearch(e) }}
                    model={this.state.model} toolbarConfig={this.toolbarConfig} modelClearTemplate={modelTemplate}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="SubModuleCode" mode={this.props.mode} allowClear={this.props.allowClear}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch} 
                    title='Sub Module' 
                    selectionCallbackMode={this.props.selectionCallbackMode}
                    promptTitle={"Remove Sub Module"}
                    promptContent={"Removing the sub module is a permanent action and the sub module will not be available going forward. Are you sure you want to remove this sub module?"}
                >
                    <SubModuleSetupSearchForm
                        data={this.state.model} 
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>  
            </ViewContainer>    
        );
    }
}


export default withRouter(withMenuPermission(SubModuleSetupSearch));